import type { Stageable } from '@/lib/entity/base'
import { nanoid } from 'nanoid'
import { GraphQLClientUi } from './graphQLClientUi'
import type { FetchResult } from '@apollo/client/core'
import { graphql } from '@/gql'
import { print } from 'graphql'
import type { Coassign_Commit_Insert_Input } from '@/gql/graphql'
import {
  mergeMutationDocuments,
  mergeMutationVariables,
  type MutationOperationAndVariables
} from './mutationHelpers'
import { sortEntities } from '@/lib/sortEntities'

function buildCommitMutationQuery(
  xs: Stageable[],
  commitId: string,
  message: string
): MutationOperationAndVariables {
  const input: Coassign_Commit_Insert_Input = {
    detail: JSON.stringify(xs),
    id: commitId,
    message: message
  }
  return { mutation: commitMutationDocument, variables: { input } }
}

async function buildMutationQuery(
  xs: Stageable[],
  commitId: string
): Promise<MutationOperationAndVariables[]> {
  const xsMutations: MutationOperationAndVariables[] = []
  for (const entity of sortEntities(xs)) {
    if (!entity.isModified() && !entity.isDeleted) continue
    if (!(await entity.isValidAsync())) throw Error('Incorrect data detected.')
    const allQueries = await entity.asMutation(commitId)
    xsMutations.push(...allQueries)
  }
  return xsMutations
}

export async function commit(
  stageableList: Stageable[],
  commitMessage: string
): Promise<FetchResult<any>> {
  const commitId = nanoid()
  const commitData = buildCommitMutationQuery(stageableList, commitId, commitMessage)

  const mutationData = await buildMutationQuery(stageableList, commitId)
  const allMutationQueries = mutationData.map((dataObj) => dataObj.mutation)
  const allMutationVariables = mutationData.map((dataObj) => dataObj.variables)

  const mergedMutationQuery = mergeMutationDocuments([commitData.mutation, ...allMutationQueries])
  const mergedMutationVariables = mergeMutationVariables(
    [commitData.variables, ...allMutationVariables],
    mergedMutationQuery.variableNameMaps
  )
  console.log(print(mergedMutationQuery.document))
  console.log(mergedMutationVariables)
  return GraphQLClientUi.executeMutation<any>(mergedMutationQuery.document, mergedMutationVariables)
}

const commitMutationDocument = graphql(/* GraphQL */ `
  mutation insertCommit($input: coassign_commit_insert_input!) {
    insert_coassign_commit_one(object: $input) {
      created_at
    }
  }
`)
